// Preview access is independent of the canonical writers' verified-user policy.
function canUseBookQuickPreview(authenticated) {
    return authenticated === true;
}

module.exports = { canUseBookQuickPreview };
